(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-gallery"] && !Shopify.designMode) return;
  try {
    
  // One viewer per page of builds. It moves through every photo of every build in grid order,
  // with thumbnails for the build you're on.
  class BuildViewer extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.gallery') || this.parentElement;
      this.dialog = this.querySelector('dialog');
      this.track = this.querySelector('[data-track]');
      this.titleEl = this.querySelector('[data-title]');
      this.metaEl = this.querySelector('[data-meta]');
      this.positionEl = this.querySelector('[data-position]');
      this.thumbsEl = this.querySelector('[data-thumbs]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.panel = this.querySelector('[data-panel]');
      this.panelTitle = this.querySelector('[data-panel-title]');
      this.panelCredit = this.querySelector('[data-panel-credit]');
      this.panelBody = this.querySelector('[data-panel-body]');
      this.toggleButton = this.querySelector('[data-details-toggle]');
      this.narrow = window.matchMedia('(max-width: 989px)');
      this.panelFor = -1;
      this.cards = Array.from(this.root.querySelectorAll('[data-build-card]'));
      this.slides = [];
      this.builds = [];
      this.index = 0;
      this.thumbsFor = -1;

      this.cards.forEach((card, cardIndex) => {
        card.querySelector('[data-build-open]').addEventListener('click', () => this.open(cardIndex));
        card.querySelector('[data-build-details-open]')?.addEventListener('click', () => this.open(cardIndex, true));
      });
      this.toggleButton.addEventListener('click', () => this.setDetails(!this.detailsOpen));

      // On phones, Esc or a tap on the photo closes the details sheet before the viewer.
      this.dialog.addEventListener('cancel', (event) => {
        if (this.detailsOpen && this.narrow.matches) {
          event.preventDefault();
          this.setDetails(false);
        }
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.prevButton.addEventListener('click', () => this.go(this.index - 1));
      this.nextButton.addEventListener('click', () => this.go(this.index + 1));

      this.dialog.addEventListener('close', () => this.onClose());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.classList.contains('build-viewer__slide')) {
          if (this.detailsOpen && this.narrow.matches) this.setDetails(false);
          else this.dialog.close();
        }
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });

      // Follows swipes. While an arrow-triggered scroll is still moving, its half-way
      // positions are ignored so quick repeated presses each count.
      this.track.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
      this.track.addEventListener('scrollend', () => {
        this.scrolling = false;
        this.syncFromScroll();
      });
    }

    // Slides are only created the first time someone opens the viewer.
    buildSlides() {
      if (this.slides.length) return;
      this.cards.forEach((card, cardIndex) => {
        const template = card.querySelector('template[data-build-photos]');
        const figures = Array.from(template.content.querySelectorAll('.build-viewer__slide'));
        this.builds.push({
          details: card.querySelector('template[data-build-details]'),
          title: template.dataset.title,
          credit: template.dataset.credit,
          start: this.slides.length,
          count: figures.length,
          thumbs: figures.map((figure) => figure.dataset.thumb),
        });
        figures.forEach((figure) => {
          const slide = figure.cloneNode(true);
          slide.dataset.build = cardIndex;
          this.track.appendChild(slide);
          this.slides.push(slide);
        });
      });
    }

    open(cardIndex, showDetails = false) {
      this.buildSlides();
      this.setDetails(showDetails);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.go(this.builds[cardIndex].start, 'instant');
    }

    // Only changes anything on phones; wide screens always show the details column.
    setDetails(open) {
      this.detailsOpen = open;
      this.dialog.classList.toggle('is-details-open', open);
      this.toggleButton.setAttribute('aria-expanded', String(open));
      this.toggleButton.textContent = open ? 'Hide details' : 'Details';
    }

    renderPanel(buildIndex) {
      if (this.panelFor === buildIndex) return;
      this.panelFor = buildIndex;
      const build = this.builds[buildIndex];
      this.panelTitle.textContent = build.title;
      this.panelCredit.textContent = build.credit ? `By ${build.credit}` : '';
      this.panelBody.replaceChildren(build.details ? build.details.content.cloneNode(true) : '');
      this.panel.scrollTop = 0;
    }

    onClose() {
      document.documentElement.style.overflow = '';
      // Back on the grid at the build you were last looking at.
      const card = this.cards[this.lastBuild ?? 0];
      card?.scrollIntoView({ block: 'center', behavior: 'instant' });
      card?.querySelector('[data-build-open]').focus({ preventScroll: true });
    }

    syncFromScroll() {
      // Closing the dialog resets its scroll position; that isn't the visitor moving.
      if (this.scrolling || !this.dialog.open) return;
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index !== this.index) {
        this.index = index;
        this.update();
      }
    }

    currentBuild() {
      return Number(this.slides[this.index]?.dataset.build || 0);
    }

    go(index, behavior = 'smooth') {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.scrolling = behavior === 'smooth';
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => (this.scrolling = false), 700); // for browsers without scrollend
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior });
      this.update();
    }

    update() {
      const buildIndex = this.currentBuild();
      const build = this.builds[buildIndex];
      if (!build) return;
      const photo = this.index - build.start;
      this.lastBuild = buildIndex;

      this.titleEl.textContent = build.title;
      const meta = [];
      if (build.credit) meta.push(`By ${build.credit}`);
      if (build.count > 1) meta.push(`Photo ${photo + 1} of ${build.count}`);
      this.metaEl.textContent = meta.join(' · ');
      this.positionEl.textContent = this.builds.length > 1 ? `Build ${buildIndex + 1} of ${this.builds.length}` : '';

      this.prevButton.disabled = this.index === 0;
      this.nextButton.disabled = this.index === this.slides.length - 1;
      this.renderPanel(buildIndex);
      this.renderThumbs(buildIndex, photo);
    }

    renderThumbs(buildIndex, photo) {
      const build = this.builds[buildIndex];
      if (this.thumbsFor !== buildIndex) {
        this.thumbsFor = buildIndex;
        this.thumbsEl.replaceChildren();
        if (build.count > 1) {
          build.thumbs.forEach((src, n) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('aria-label', `Photo ${n + 1} of ${build.count}`);
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            button.appendChild(img);
            button.addEventListener('click', () => this.go(build.start + n));
            this.thumbsEl.appendChild(button);
          });
        }
      }
      Array.from(this.thumbsEl.children).forEach((button, n) => {
        button.setAttribute('aria-current', n === photo ? 'true' : 'false');
      });
      this.thumbsEl.children[photo]?.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }

  if (!customElements.get('build-viewer')) {
    customElements.define('build-viewer', BuildViewer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-submit"] && !Shopify.designMode) return;
  try {
    
  class CommunitySubmitForm extends HTMLElement {
    static CHUNK_SIZE = 10 * 1024 * 1024;
    static MAX_PHOTOS = 6;
    static MAX_PHOTO_MB = 25;
    static PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
    static VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'];

    // MKV isn't accepted by Shopify, so MKVs (usually OBS recordings) are repackaged as MP4 in the
    // visitor's own browser before uploading. The converter (~30 MB) only downloads when an MKV is picked.
    static MAX_MKV_MB = 600;
    static CONVERTER = {
      script: 'https://cdn.jsdelivr.net/npm/@ffmpeg/ffmpeg@0.12.15/dist/umd/ffmpeg.js',
      worker: 'https://cdn.jsdelivr.net/npm/@ffmpeg/ffmpeg@0.12.15/dist/esm/worker.js',
      core: 'https://cdn.jsdelivr.net/npm/@ffmpeg/core@0.12.10/dist/esm/ffmpeg-core.js',
      wasm: 'https://cdn.jsdelivr.net/npm/@ffmpeg/core@0.12.10/dist/esm/ffmpeg-core.wasm',
    };
    static MKV_HELP =
      "We couldn't convert this MKV automatically. In OBS, use File → Remux Recordings to turn it into an MP4 (it takes a few seconds), or convert it with the free HandBrake app, then upload the MP4.";

    static isMkv(file) {
      return /\.mkv$/i.test(file.name) || file.type === 'video/x-matroska';
    }

    connectedCallback() {
      this.apiUrl = (this.dataset.apiUrl || '').replace(/\/+$/, '');
      this.form = this.querySelector('form');
      this.errorBox = this.querySelector('[data-error]');
      this.success = this.querySelector('[data-success]');
      if (this.dataset.mode === 'report') return this.setupReport();

      this.maxVideoMb = Number(this.dataset.maxVideoMb) || 1024;
      this.typeSelect = this.form.elements.type;
      // The guidelines link opens in a new tab, so a half-filled form isn't lost.
      this.querySelectorAll('.community-submit__consent a').forEach((link) => {
        link.target = '_blank';
        link.rel = 'noopener';
      });
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.progress = this.querySelector('[data-progress]');
      this.progressBar = this.progress.querySelector('progress');
      this.progressText = this.progress.querySelector('[data-progress-text]');

      this.typeSelect.addEventListener('change', () => this.showFieldsFor(this.typeSelect.value));
      this.showFieldsFor(this.typeSelect.value);
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submit();
      });
    }

    // Report mode: the page is opened from a "Report" link, which says what is being reported.
    setupReport() {
      const params = new URLSearchParams(window.location.search);
      this.report = { entry: params.get('entry') || '', title: params.get('title') || '', from: params.get('from') || '' };

      if (!/^gid:\/\/shopify\/Metaobject\/\d+$/.test(this.report.entry)) {
        this.querySelector('[data-report-missing]').hidden = false;
        this.form.querySelectorAll('input, select, textarea, button').forEach((element) => (element.disabled = true));
        return;
      }

      const target = this.querySelector('[data-report-target]');
      target.hidden = false;
      target.querySelector('[data-report-title]').textContent = this.report.title || 'this item';

      const reason = this.form.elements.reason;
      reason.addEventListener('change', () => {
        this.form.elements.details.required = reason.value !== 'offensive';
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.sendReport();
      });
    }

    async sendReport() {
      this.errorBox.hidden = true;
      if (!this.form.reportValidity()) return;
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;

      try {
        await this.request('/api/reports', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...this.report,
            reason: this.form.elements.reason.value,
            email: this.form.elements.email.value.trim(),
            details: this.form.elements.details.value.trim(),
            accurate: this.form.elements.accurate.checked,
            turnstileToken: this.querySelector('[name="cf-turnstile-response"]')?.value || '',
          }),
        });
        this.form.hidden = true;
        this.success.hidden = false;
        this.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        button.disabled = false;
        window.turnstile?.reset();
        this.showError(error.message);
      }
    }

    // Only the fields for the chosen type are shown, required and sent.
    showFieldsFor(type) {
      this.querySelectorAll('[data-show-for]').forEach((field) => {
        const visible = field.dataset.showFor.split(' ').includes(type);
        field.hidden = !visible;
        field.querySelectorAll('input, select, textarea').forEach((input) => {
          input.disabled = !visible;
        });
      });
    }

    showError(message) {
      this.errorBox.textContent = message;
      this.errorBox.hidden = false;
      this.errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    checkFiles(type, files) {
      if (type === 'build') {
        if (files.length > CommunitySubmitForm.MAX_PHOTOS) {
          return `Please choose up to ${CommunitySubmitForm.MAX_PHOTOS} photos.`;
        }
        for (const file of files) {
          if (!CommunitySubmitForm.PHOTO_TYPES.includes(file.type)) {
            return `"${file.name}" isn't a JPG, PNG or WebP photo.`;
          }
          if (file.size > CommunitySubmitForm.MAX_PHOTO_MB * 1024 * 1024) {
            return `"${file.name}" is over ${CommunitySubmitForm.MAX_PHOTO_MB} MB.`;
          }
        }
      } else {
        const video = files[0];
        if (CommunitySubmitForm.isMkv(video)) {
          if (video.size > CommunitySubmitForm.MAX_MKV_MB * 1024 * 1024) {
            return `MKV videos over ${CommunitySubmitForm.MAX_MKV_MB} MB are too big to convert in your browser. ${CommunitySubmitForm.MKV_HELP}`;
          }
          return null;
        }
        if (!CommunitySubmitForm.VIDEO_TYPES.includes(video.type)) {
          return 'Please choose an MP4, MOV, WebM or MKV video.';
        }
        if (video.size > this.maxVideoMb * 1024 * 1024) {
          return `That video is over ${this.maxVideoMb} MB. Try exporting it at 1080p.`;
        }
      }
      if (files.some((file) => file.size === 0)) return 'One of the files is empty.';
      return null;
    }

    async loadConverter() {
      if (CommunitySubmitForm.converter) return CommunitySubmitForm.converter;
      const { script, worker, core, wasm } = CommunitySubmitForm.CONVERTER;
      // Browsers only start background workers from the page's own address, so a one-line starter is
      // made in memory; it then imports the converter's modern (ESM) files from the CDN.
      const workerStarter = URL.createObjectURL(new Blob([`import ${JSON.stringify(worker)};`], { type: 'text/javascript' }));
      if (!window.FFmpegWASM) {
        await new Promise((resolve, reject) => {
          const tag = document.createElement('script');
          tag.src = script;
          tag.onload = resolve;
          tag.onerror = reject;
          document.head.appendChild(tag);
        });
      }
      const ffmpeg = new window.FFmpegWASM.FFmpeg();
      await ffmpeg.load({ classWorkerURL: workerStarter, coreURL: core, wasmURL: wasm });
      CommunitySubmitForm.converter = ffmpeg;
      return ffmpeg;
    }

    // Repackages an MKV as an MP4 without re-encoding (lossless and quick).
    async convertMkv(file) {
      const status = (text, percent) => {
        this.progressBar.value = percent;
        this.progressText.textContent = text;
      };
      status('Getting the video converter ready (one-time download, about 30 MB)…', 0);

      let ffmpeg;
      try {
        ffmpeg = await this.loadConverter();
      } catch (error) {
        console.error(error);
        throw new Error(`We couldn't load the video converter. ${CommunitySubmitForm.MKV_HELP}`);
      }

      const onProgress = ({ progress }) => {
        const percent = Math.max(0, Math.min(99, Math.round(progress * 100)));
        status(`Preparing your video… ${percent}%`, percent);
      };
      ffmpeg.on('progress', onProgress);
      status('Preparing your video…', 0);
      try {
        await ffmpeg.writeFile('input.mkv', new Uint8Array(await file.arrayBuffer()));
        const exitCode = await ffmpeg.exec([
          '-i', 'input.mkv',
          '-map', '0:v:0', '-map', '0:a:0?',
          '-c', 'copy',
          '-movflags', '+faststart',
          'output.mp4',
        ]);
        if (exitCode !== 0) throw new Error(`ffmpeg exited with ${exitCode}`);
        const data = await ffmpeg.readFile('output.mp4');
        return new File([data], `${file.name.replace(/\.mkv$/i, '')}.mp4`, { type: 'video/mp4' });
      } catch (error) {
        console.error(error);
        throw new Error(CommunitySubmitForm.MKV_HELP);
      } finally {
        ffmpeg.off('progress', onProgress);
        await ffmpeg.deleteFile('input.mkv').catch(() => {});
        await ffmpeg.deleteFile('output.mp4').catch(() => {});
      }
    }

    async request(path, options) {
      const response = await fetch(`${this.apiUrl}${path}`, options);
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || 'Something went wrong. Please try again.');
      return body;
    }

    async uploadPart(id, uploadToken, index, partNumber, blob) {
      for (let attempt = 1; ; attempt++) {
        try {
          return await this.request(`/api/submissions/${id}/files/${index}/parts/${partNumber}`, {
            method: 'PUT',
            headers: { 'X-Upload-Token': uploadToken },
            body: blob,
          });
        } catch (error) {
          if (attempt === 3) throw error;
          await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));
        }
      }
    }

    setProgress(done, total) {
      const percent = total ? Math.round((done / total) * 100) : 0;
      this.progressBar.value = percent;
      this.progressText.textContent = percent < 100 ? `Uploading… ${percent}%` : 'Finishing up…';
    }

    async submit() {
      this.errorBox.hidden = true;
      if (!this.form.reportValidity()) return;

      const data = new FormData(this.form);
      const type = data.get('type');
      const fileInput = type === 'build' ? this.form.elements.photos : this.form.elements.video;
      let files = Array.from(fileInput.files);
      const fileProblem = this.checkFiles(type, files);
      if (fileProblem) return this.showError(fileProblem);

      const fields = {};
      for (const [key, value] of data.entries()) {
        if (typeof value === 'string' && !['type', 'permission', 'cf-turnstile-response'].includes(key)) {
          fields[key] = value.trim();
        }
      }

      this.submitButton.disabled = true;
      this.progress.hidden = false;
      this.setProgress(0, 1);

      try {
        if (type === 'sound_test' && CommunitySubmitForm.isMkv(files[0])) {
          files = [await this.convertMkv(files[0])];
          if (files[0].size > this.maxVideoMb * 1024 * 1024) {
            throw new Error(`That video is over ${this.maxVideoMb} MB. Try exporting it at 1080p.`);
          }
          this.setProgress(0, 1);
        }

        const submission = await this.request('/api/submissions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            type,
            fields,
            permission: data.get('permission') === 'yes',
            permissionText: this.querySelector('label[for^="CommunitySubmitPermission"]')?.textContent.trim() || '',
            permissionLink: this.querySelector('.community-submit__consent a')?.href || '',
            turnstileToken: data.get('cf-turnstile-response') || '',
            files: files.map((file) => ({ name: file.name, size: file.size, type: file.type })),
          }),
        });

        const totalBytes = files.reduce((sum, file) => sum + file.size, 0);
        let uploadedBytes = 0;
        const completed = [];

        for (const [index, file] of files.entries()) {
          const parts = [];
          for (let offset = 0, partNumber = 1; offset < file.size; offset += CommunitySubmitForm.CHUNK_SIZE, partNumber++) {
            const blob = file.slice(offset, offset + CommunitySubmitForm.CHUNK_SIZE);
            const { etag } = await this.uploadPart(submission.id, submission.uploadToken, index, partNumber, blob);
            parts.push({ partNumber, etag });
            uploadedBytes += blob.size;
            this.setProgress(uploadedBytes, totalBytes);
          }
          completed.push({ index, parts });
        }

        await this.request(`/api/submissions/${submission.id}/complete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uploadToken: submission.uploadToken, files: completed }),
        });

        this.form.hidden = true;
        this.progress.hidden = true;
        this.success.hidden = false;
        this.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        this.progress.hidden = true;
        this.submitButton.disabled = false;
        window.turnstile?.reset();
        this.showError(error.message);
      }
    }
  }

  if (!customElements.get('community-submit-form')) {
    customElements.define('community-submit-form', CommunitySubmitForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sound-tests-gallery"] && !Shopify.designMode) return;
  try {
    
  // Only one sound test should play at a time.
  document.addEventListener(
    'play',
    (event) => {
      if (!event.target.closest || !event.target.closest('.sound-test-card__video')) return;

      document.querySelectorAll('.sound-test-card__video video').forEach((video) => {
        if (video !== event.target) video.pause();
      });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
